import ProjectSession from "../project-session"
import {ProjectAccess} from "../../../gd/const/project"

export default function canCreateEvent(project: ProjectSession) {


    // cant add event to archived projects
    if (gd.const.systemStatus.isClosed(project.systemStatus)) return false

    // no events in tags
    if (project.systemType === gd.const.project.type.TAG) return false

    // in templates we do not have users
    if (project.isTemplate) {
        return true
    }

    // make sure project user exists
    const projectUser = gd.session.projectUsers.findByProjectAndUser(project.id, gd.user.id)
    if (!projectUser) return false

    // verify with projectAccess settings if any
    switch (projectUser.access) {
        case ProjectAccess.FULL:
        case ProjectAccess.STANDARD:
            return true

        case ProjectAccess.LIMITED:
        case ProjectAccess.CLIENT:
        case ProjectAccess.READ_ONLY:
            return false
        default:
            console.error("canCreateEvent error: unknown option")
            return false
    }



    return true
}